export default function getProductHeaderData(props) {
  const {
    headerTitle,
    headerIntro,
    headerImage,
    headerImageMask,
    headerButtonProductDemo,
    headerButtonRequestDemo,
    buttons,
  } = props;

  const data = {};
  data.title = headerTitle || false;
  data.description = headerIntro || false;

  data.figureMask = headerImageMask?.fields?.file ? {} : false;
  if (data.figureMask) {
    data.figureMask.alt = headerImageMask?.fields?.title || false;
    data.figureMask.src = headerImageMask?.fields?.file.url || false;
    data.figureMask.width = headerImageMask?.fields?.file.details?.image?.width || false;
    data.figureMask.height = headerImageMask?.fields?.file.details?.image?.height || false;
  }

  data.figureScreen = headerImage?.fields?.file ? {} : false;
  if (data.figureScreen) {
    data.figureScreen.alt = headerImage?.fields?.title || false;
    data.figureScreen.src = headerImage?.fields?.file.url || false;
    data.figureScreen.width = headerImage?.fields?.file.details?.image?.width || false;
    data.figureScreen.height = headerImage?.fields?.file.details?.image?.height || false;
  }

  data.buttons = [];
  if (headerButtonProductDemo?.fields?.text) {
    const productDemoButton = {};
    productDemoButton.label = headerButtonProductDemo.fields.text;
    productDemoButton.modifier = 'Button--electricPurpleFill';
    productDemoButton.url = headerButtonProductDemo.fields.url;
    data.buttons.push(productDemoButton);
  }

  if (headerButtonRequestDemo?.fields?.text) {
    const requestDemoButton = {};
    requestDemoButton.label = headerButtonRequestDemo.fields.text;
    requestDemoButton.modifier = 'Button--electricPurple';
    requestDemoButton.url = headerButtonRequestDemo.fields.url;
    data.buttons.push(requestDemoButton);
  }

  if (buttons) {
    buttons.forEach((button) => {
      const genericButton = {};
      genericButton.label = button.fields.text;
      genericButton.modifier = 'Button--electricPurpleFill';
      genericButton.url = button.fields.url;
      data.buttons.push(genericButton);
    });
  }

  return Object.keys(data).length ? data : false;
}
